import * as yup from 'yup';

export const validationSchema = (t) =>
  yup.object({
    username: yup
      .string()
      //.min(5, 'Минимум 5 символов')
      .required(t('required.Заполните поле')),
    password: yup.string().required(t('required.Заполните поле')),
  });
